export const LEVEL_ERROR = 0;
export const LEVEL_WARN = 1;
export const LEVEL_INFO = 2;
export const LEVEL_DEBUG = 3;
export enum LogLevel {
  LEVEL_ERROR,
  LEVEL_WARN,
  LEVEL_INFO,
  LEVEL_DEBUG,
}
export interface LogEvent {
  level: LogLevel;
  message: string;
  args: unknown[];
  time: Date;
  tag?: string;
}

export abstract class Appender {
  protected _level: LogLevel | undefined;
  public get level(): LogLevel | undefined {
    return this._level;
  }
  public set level(v: LogLevel | undefined) {
    this._level = v;
  }

  log(e: LogEvent) {
    if (this.level && e.level > this.level) return;
    this.append(e);
  }

  abstract append(e: LogEvent): void;
}

export interface LoggingConfig {
  appenders?: Appender[];
  level?: LogLevel;
}
class Logger {
  private _level: LogLevel = LogLevel.LEVEL_INFO;
  public get level(): LogLevel {
    return this._level;
  }
  public set level(v: LogLevel) {
    this._level = v;
    this.appenders.forEach((app) => (app.level = v));
  }

  private _appenders: Appender[] = [];
  public get appenders(): Appender[] {
    return this._appenders;
  }
  public set appenders(v: Appender[]) {
    this._appenders = v;
  }

  private _configured = false;
  public get configured(): boolean {
    return this._configured;
  }

  log(
    tag: string | undefined,
    level: LogLevel,
    message: string,
    args: unknown[]
  ) {
    if (level > this.level) {
      return;
    }
    const e: LogEvent = { tag, level, message, args, time: new Date() };
    for (const app of this.appenders) {
      app.log(e);
    }
  }

  public configure({ level, appenders }: LoggingConfig) {
    if (level) this.level = level;
    if (appenders) this.appenders = appenders;
    this._configured = true;
  }
}

const logger = new Logger();
export default logger;
